import { readNotebooksTable } from '.';
import { getOwnerID } from '../../utils/DryCookies';
import logger from '../../logger';
import { HasNotebooksLocalDatabaseContentType } from '../../types/notebooks';

type NotebookType = {
  notebook_id: string;
};

export const checkNotebooksLocalDatabaseContent = async () => {
  console.log('hasNotebooksLocalDatabaseContent');
  const ownerId = getOwnerID() as string;
  let hasNotebooksLocalDatabaseContent = false as HasNotebooksLocalDatabaseContentType;
  if (!ownerId) {
    logger.info('Local database content NOT FOUND');
    return {
      hasNotebooksLocalDatabaseContent: hasNotebooksLocalDatabaseContent,
    };
  }

  try {
    const notebooksLocalDatabaseContent = await readNotebooksTable({ ownerId });
    logger.debug(notebooksLocalDatabaseContent, 'Local database content FOUND');
    const notebooksObject: { [key: string]: NotebookType } = {};
    notebooksLocalDatabaseContent.forEach((element: NotebookType) => {
      notebooksObject[element.notebook_id] = element;
    });
    return {
      notebooks: notebooksObject,
      hasNotebooksLocalDatabaseContent: Boolean(notebooksLocalDatabaseContent.length),
    };
  } catch (error) {
    logger.error(error, 'Local database content NOT FOUND');
    return {
      hasNotebooksLocalDatabaseContent: false,
    };
  }
};
